<template>
    <div>
        <top-header/>
        <div class="container-fluid mt-4" style="margin-bottom: 10rem;">
            <h1 class="text-info">Orientation and FAQ</h1>
            <hr/>
            <p class="text-secondary">
                Please take a moment to view the video orientation presented by Dr. Paul Harris and review the Frequently Asked Questions (FAQ) below.
            </p>

            <orientation-video/>

            <faq class="mt-4"/>

        </div>
        <bottom-footer/>
    </div>
</template>

<script>
    import BottomFooter from "../decorators/BottomFooter";
    import TopHeader from "../TopHeader";
    import OrientationVideo from "./OrientationVideo";
    import Faq from "./Faq";

    export default {
        name: "HelpInfo",
        components: {Faq, OrientationVideo, TopHeader, BottomFooter}
    }
</script>

<style scoped>

</style>
